var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('item-create-view',{scopedSlots:_vm._u([{key:"default",fn:function(_){return [_c('shift-edit-form',{attrs:{"disabled":_.itemDisabled},model:{value:(_.item),callback:function ($$v) {_vm.$set(_, "item", $$v)},expression:"_.item"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }